export const CRM_STAGE_COLORS = ['#64748B', '#2563EB', '#0891B2', '#D97706', '#7C3AED', '#16A34A', '#EF4444']

export function getCrmStageColor(position, fallbackIndex = 0) {
  const parsedPosition = Number(position)
  const index = Number.isFinite(parsedPosition) && parsedPosition > 0
    ? parsedPosition - 1
    : fallbackIndex
  return CRM_STAGE_COLORS[index % CRM_STAGE_COLORS.length]
}
